import {
    ExternalCurrentTransportLeg,
    ExternalEndOfTransportChain,
    ExternalPriority,
    ExternalStartOfTransportChain,
    ExternalTransportOrder,
    ExternalTransportOrderBundle,
} from "../client/transportorder-hub/model"
import { ExternalGoods } from "../client/transportorder-hub/goods.model"
import { createExternalGoodsCargoMaterial } from "./transportOrderGoodsHelper"

export const createExternalStartOfTransportChain =
    (overrides: Partial<ExternalStartOfTransportChain> = {}): ExternalStartOfTransportChain => ({
        pickup_requested_at: {
            time_from: "2022-04-19T10:00:00Z",
            time_to: "2022-04-19T10:00:00Z"
        },
        place_of_loading: "Beladestelle",
        consignor: {
            name: "Continental Werk Frankfurt",
            address: {
                street: "Guerickestraße 7",
                postal_code: "60488",
                city: "Frankfurt",
                country: "DE"
            },
            external_identifiers: {
                duns: "004380264",
                plant_code: "901024039",
                supplier_code: "TEST000002"
            },
        },
        ...overrides,
    })

export const createExternalEndOfTransportChain =
    (overrides: Partial<ExternalEndOfTransportChain> = {}): ExternalEndOfTransportChain => ({
        delivery_estimated_at: {
            time_from: "2022-04-19T22:00:00Z",
            time_to: "2022-04-19T22:00:00Z"
        },
        place_of_discharge: "Abladestelle",
        consignee: {
            name: "Audi AG - Tor 11",
            address: {
                street: "Ettinger Str. 105",
                postal_code: "85057",
                city: "Ingolstadt",
                country: "DE"
            },
            external_identifiers: {
                supplier_code: "Test1234",
                plant_code: "Test03",
            },
        },
        ...overrides,
    })

export const createExternalCurrentTransportLeg =
    (overrides: Partial<ExternalCurrentTransportLeg> = {}): ExternalCurrentTransportLeg => {
        const startOfTransportChain = createExternalStartOfTransportChain()
        const endOfTransportChain = createExternalEndOfTransportChain()
        return {
            place_of_departure: {
                name: startOfTransportChain.consignor.name,
                address: startOfTransportChain.consignor.address,
                external_identifiers: startOfTransportChain.consignor.external_identifiers,
            },
            departure_requested_at: startOfTransportChain.pickup_requested_at,
            place_of_arrival: {
                name: endOfTransportChain.consignee.name,
                address: endOfTransportChain.consignee.address,
                external_identifiers: endOfTransportChain.consignee.external_identifiers,
            },
            arrival_estimated_at: endOfTransportChain.delivery_estimated_at,
            ...overrides,
        }
    }

export const createExternalTransportOrderBundle =
    (transportOrderOverrides: Partial<ExternalTransportOrder> = {}, goods: ExternalGoods = createExternalGoodsCargoMaterial()): ExternalTransportOrderBundle =>
        ({
            id: "7b9f7c6b-2433-42ba-b682-de89fa4e5990",
            _embedded: {
                transport_orders: [
                    {
                        id: "8b7b9434-6e64-425d-b920-7b73c48e7bf4",
                        bundle_id: "7b9f7c6b-2433-42ba-b682-de89fa4e5990",
                        external_id: "Source-Document-Identifier",
                        priority: ExternalPriority.URGENT,
                        proposed_vehicle_type: "MEDIUM_TRUCK",
                        external_order_created_date: "2018-09-01T14:06:00Z",
                        buyer: {
                            name: "Audi AG - Tor 11",
                            address: {
                                street: "Buyer street",
                                city: "Buyer city",
                                country: "BY",
                                postal_code: "66666"
                            }
                        },
                        supplier: {
                            name: "Continental Werk Frankfurt",
                            address: {
                                street: "Guerickestraße 7",
                                postal_code: "60488",
                                city: "Frankfurt",
                                country: "DE"
                            },
                            external_identifiers: {
                                duns: "004380264",
                                plant_code: "901024039",
                                supplier_code: "TEST000002"
                            },
                        },
                        freight_forwarder: {
                            name: "Speedy Logistics GmbH",
                            duns: "123456789",
                            account_id: "ff-account-001",
                            supplier_code: "FFSUPPLIER001",
                            address: {
                                street: "Logistics Street 1",
                                postal_code: "12345",
                                city: "Logistic City",
                                country: "DE"
                            }
                        },
                        freight_payer: {
                            name: "AUDI Ingolstadt",
                        },
                        process_indicator: "LTL",
                        goods,
                        start_of_transport_chain: createExternalStartOfTransportChain(),
                        end_of_transport_chain: createExternalEndOfTransportChain(),
                        current_transport_leg: createExternalCurrentTransportLeg(),
                        cancelled: false,
                        last_modified_at: "2022-04-19T12:45:42.968Z",
                        etag: 0,
                        ...transportOrderOverrides,
                    }
                ]
            },
            created_at: "2022-04-19T12:45:42.968Z",
        })
